fragment pronunciationDetails on PronunciationType {
  id
  description
}
